import { Avatar, ButtonBase, Menu, MenuItem, SvgIcon, Typography } from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { capitalize, get } from 'lodash';
import React, { ComponentType, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getProfileImage } from 'src/common/utils/format-utils';
import { ROUTES } from 'src/constants/routes';
import { useAuth } from '../../hooks';
import { SolidDropdownIcon, UserIcon } from '../icons';
import useStyles from './styles';

export const UserMenu: ComponentType<BoxProps & { variant?: 'light' | 'dark' }> = ({
  variant = 'dark',
  ...props
}) => {
  const classes = useStyles({ variant });
  const { user, handleLogout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const fullName = [capitalize(get(user, 'data.lastName')), capitalize(get(user, 'data.firstName'))]
    .filter(Boolean)
    .join(' ');

  const profileImage = getProfileImage(get(user, 'data.passportPhoto'));

  return (
    <Box className={classes.root} {...props}>
      <ButtonBase
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={classes.button}
      >
        <Avatar className={classes.avatar} src={profileImage}>
          <SvgIcon component={UserIcon} viewBox="0 0 24 24" />
        </Avatar>
        <Typography variant="body2" color="text">
          {fullName}
        </Typography>
        <SvgIcon component={SolidDropdownIcon} viewBox="0 0 24 24" />
      </ButtonBase>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        classes={{
          paper: classes.dropdown,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem component={Link} to={ROUTES.HOME}>
          {t('homepage', 'Главная')}
        </MenuItem>
        <MenuItem component={Link} to={ROUTES.CABINET}>
          {t('cabinet', 'Кабинет')}
        </MenuItem>
        <MenuItem className={classes.dropdownItem} onClick={handleLogout}>
          {t('logout', 'Выйти')}
        </MenuItem>
      </Menu>
    </Box>
  );
};
